'use strict';

var PricingSummaryPanelController = function PricingSummaryPanelController($scope, $rootScope, dataRetrieverService) {
  $scope.brushFilters = {};
  $scope.charts = {
    pos: {
      id: 'pos',
      isExpanded: false
    },
    od: {
      id: 'od',
      isExpanded: false
    }
  };
  $scope.onExpandIconClick = function (chartId) {
    if (chartId === $scope.charts.pos.id) {
      $scope.charts.pos.isExpanded = !$scope.charts.pos.isExpanded;
      $scope.charts.od.isExpanded = false;
    }
    if (chartId === $scope.charts.od.id) {
      $scope.charts.od.isExpanded = !$scope.charts.od.isExpanded;
      $scope.charts.pos.isExpanded = false;
    }
    $rootScope.$broadcast('PricingBarChart:chartState:changed');
  };
  $scope.updateBrushes = function (brushFilter) {
    if (!brushFilter.isEmpty()) {
      $scope.brushFilters[brushFilter.filterType] = brushFilter;
    } else {
      delete $scope.brushFilters[brushFilter.filterType];
    }
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
    $rootScope.$broadcast('brush-filter:filterApplied', brushFilter);
  };
  $scope.resetBrushes = function () {
    $scope.brushFilters = {};
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
  };
};
PricingSummaryPanelController.$inject = ['$scope', '$rootScope', 'DataRetrieverService'];
module.exports = PricingSummaryPanelController;